import React from 'react';
import classes from './AskInvite.module.scss';
import Button from 'components/UI/Button/Button';
import {useTranslation} from 'react-i18next';

const AskInvite = () => {
  const {t} = useTranslation();

  const onClick = () => {
    window.location.href = process.env.REACT_APP_REVIEW_URL;
  }

  return (
      <div>
        <h1>{t('invite')}</h1>

        <div className={classes.description}>
          {t('inviteMessage')}
        </div>

        <Button onClick={onClick} type="primary">{t('goMain')}</Button>
      </div>
  );
};

export default AskInvite;
